// Phase 3I.4P.3 — Canonical Industry catalogue (frontend mirror).
// Stable slugs must match `backend/services/industries.py` exactly.

export const INDUSTRY_CATALOGUE = [
  { slug: "real_estate",                label: "Real Estate" },
  { slug: "property_development",       label: "Property Development" },
  { slug: "property_management",        label: "Property Management" },
  { slug: "mortgage_finance",           label: "Mortgage / Finance" },
  { slug: "accounting",                 label: "Accounting" },
  { slug: "legal",                      label: "Legal" },
  { slug: "construction",               label: "Construction" },
  { slug: "trades_contractors",         label: "Trades & Contractors" },
  { slug: "interior_design",            label: "Interior Design" },
  { slug: "architecture",               label: "Architecture" },
  { slug: "automotive",                 label: "Automotive" },
  { slug: "car_rental",                 label: "Car Rental" },
  { slug: "supercar_luxury_car_rental", label: "Supercar / Luxury Car Rental" },
  { slug: "hospitality",                label: "Hospitality" },
  { slug: "restaurants_food",           label: "Restaurants & Food" },
  { slug: "hotels",                     label: "Hotels" },
  { slug: "beauty_wellness",            label: "Beauty & Wellness" },
  { slug: "healthcare",                 label: "Healthcare" },
  { slug: "dental",                     label: "Dental" },
  { slug: "fitness",                    label: "Fitness" },
  { slug: "education",                  label: "Education" },
  { slug: "nursery_childcare",          label: "Nursery / Childcare" },
  { slug: "retail",                     label: "Retail" },
  { slug: "ecommerce",                  label: "Ecommerce" },
  { slug: "fashion",                    label: "Fashion" },
  { slug: "technology",                 label: "Technology" },
  { slug: "software_saas",              label: "Software / SaaS" },
  { slug: "marketing_creative",         label: "Marketing / Creative" },
  { slug: "media_entertainment",        label: "Media / Entertainment" },
  { slug: "music",                      label: "Music" },
  { slug: "events",                     label: "Events" },
  { slug: "travel_tourism",             label: "Travel & Tourism" },
  { slug: "logistics",                  label: "Logistics" },
  { slug: "transport",                  label: "Transport" },
  { slug: "recruitment",                label: "Recruitment" },
  { slug: "consulting",                 label: "Consulting" },
  { slug: "insurance",                  label: "Insurance" },
  { slug: "financial_services",         label: "Financial Services" },
  { slug: "membership_subscription",    label: "Membership / Subscription Business" },
  { slug: "professional_services",      label: "Professional Services" },
  { slug: "home_services",              label: "Home Services" },
  { slug: "security",                   label: "Security" },
  { slug: "other",                      label: "Other" },
];

const _LABEL_BY_SLUG = Object.fromEntries(INDUSTRY_CATALOGUE.map((r) => [r.slug, r.label]));

export function industryLabel(slug) {
  if (!slug) return null;
  return _LABEL_BY_SLUG[slug] || slug; // Legacy free-text values pass through.
}

export function isCanonicalIndustry(slug) {
  if (!slug) return true;
  return slug in _LABEL_BY_SLUG;
}
